import type { Visibility } from '@train2volley/shared';
import { VISIBILITY } from '@/lib/exercise-labels';

/** Privé · Club · Openbaar, altijd met icoon (status nooit alleen met kleur). */
export function VisibilityBadge({ value }: { value: Visibility }) {
  const v = VISIBILITY[value];
  return (
    <span className="inline-flex items-center gap-1 text-xs font-medium text-muted-foreground">
      <v.icon className="size-3.5" aria-hidden="true" />
      {v.label}
    </span>
  );
}
